// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/option.js';

import { paths } from '../generated/option';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('option', Original, paths);
